import React from 'react';
import { STATES } from '../api';
import { Attachments, Field, Select } from '../ui';

export const DeliveryFields = ({ bind, user, files, setFiles }) => <>
  <h2>Where and when do you need it?</h2>
  <Field id="rfq-destination" label="Full delivery address" placeholder="Company, street, area and city"
    area minLength={8} required {...bind('destination')} />
  <div className="form-grid">
    <Select id="rfq-state" label="Delivery state" {...bind('state_code')}>
      {STATES.map(([code, name]) => <option value={code} key={code}>{name}</option>)}
    </Select>
    <Field id="rfq-pincode" label="PIN code" pattern="[1-9][0-9]{5}" maxLength={6}
      placeholder="411001" required {...bind('pincode')} />
  </div>
  <Select id="rfq-timeline" label="Required timeline" {...bind('timeline')}>
    {['Within 7 days', 'Within 2 weeks', 'Within 30 days', 'Flexible'].map(value => <option key={value}>{value}</option>)}
  </Select>
  <Field id="rfq-notes" label="Technical requirements / additional notes" area
    placeholder="Grade, dimensions, packing requirements or custom specifications…" {...bind('notes')} />
  {user ? <Attachments id="rfq-attachments" files={files} setFiles={setFiles} />
    : <p className="notice" data-testid="rfq-attachment-signin-notice">Sign in to attach documents.</p>}
</>;